import { createStore } from 'vuex'
import * as loading from './modules/loading'

const store = createStore({
  modules: {
    loading: {
      namespaced: true,
      ...loading
    }
  }
})

export default store

// Export the actions directly
export const { startRequest, finishRequest } = loading